const registeredEvents = {};
const pendingEvents = [];

let engineReady = false;
let getContext = null;
let updateContext = null;

// 🔌 Engine init
export const initEngine = ({ _getContext, _updateContext }) => {
  if (engineReady) return;

  getContext = _getContext;
  updateContext = _updateContext;
  engineReady = true;

  // flush queued events
  pendingEvents.forEach(({ eventName, payload }) =>
    triggerEvent(eventName, payload)
  );
  pendingEvents.length = 0;

  console.log("✅ Engine initialized");
};

// 📌 Register handlers
export const registerEvent = (eventName, callback) => {
  if (!registeredEvents[eventName]) {
    registeredEvents[eventName] = [];
  }

  registeredEvents[eventName].push(callback);

  return () => {
    registeredEvents[eventName] =
      registeredEvents[eventName].filter(cb => cb !== callback);
  };
};

// 🚀 Trigger
export const triggerEvent = (eventName, payload) => {
  if (!engineReady) {
    pendingEvents.push({ eventName, payload });
    return;
  }

  if (registeredEvents[eventName]) {
    registeredEvents[eventName].forEach(cb =>
      cb(payload, { getContext, updateContext })
    );
  }
};
